"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var Authentication_1 = require("src/Authentication");
var CurrentUser_1 = require("src/CurrentUser");
var UserCart_1 = require("../UserCart/UserCart");
var LogoutPage = /** @class */ (function (_super) {
    __extends(LogoutPage, _super);
    function LogoutPage(props) {
        var _this = _super.call(this, props) || this;
        Authentication_1.AuthToken.clearTokens();
        _this.props.currentUser.refetch();
        _this.props.userCart.refetch();
        var params = new URLSearchParams(_this.props.location.search);
        var redirectUrl = params.get('redirect_url') || '/login';
        _this.props.history.push(redirectUrl);
        return _this;
    }
    LogoutPage.prototype.render = function () {
        return null;
    };
    return LogoutPage;
}(React.Component));
exports.default = react_router_1.withRouter(UserCart_1.withUserCart(CurrentUser_1.withCurrentUser(LogoutPage)));
